module.exports = __webpack_public_path__ + "static/media/DSCF0254-OPmoiYgs.dec6c0ca.JPG";